import { React } from "react";

function OmOss () {

    return(

         <section className="flex flex-col items-center py-14 px-6 bg-beige-light ">
            <h2 className="text-3xl font-serif mb-8 ">Om oss</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8 sm:gap-16 md:gap-20">
            <div className="mt-8">
                <img
                    src="/bilder/amanda.jpeg"
                    alt="Eleven australia"
                    className="rounded rounded-sm w-full md:h-96 object-contain mx-auto"
                />
                <h2 className="text-2xl md:text-2xl font-serif mb-2 mt-4">Amanda</h2>
                <p className="leading-relaxed md:leading-normal max-w-prose">
                    Jag heter Amanda och har arbetat som frisör sedan juni 2019. Frisöryrket är mer än ett jobb för mig, det är en passion. Jag älskar att få vara kreativ, utvecklas och framför allt att få skapa en stund där du som kund känner dig helt sedd och omhändertagen.<br/>
                    <br/>
                    För mig är det viktigt att varje besök i stolen ska kännas som en lyxig paus i vardagen, där du kan slappna av, bli lyssnad på och lämna salongen med ett hår du verkligen trivs i. Jag lägger stor vikt vid detaljer, kvalitet och att resultatet ska passa just dig. 
                    Varmt välkommen till min stol!</p>
            </div>
            {/* <hr className="border-t-2 border-brown-dark my-2 w-full mx-auto" /> */}
            <div className="mt-8">
                <img
                    src="/bilder/filippa.jpeg"
                    alt="Eleven australia"
                    className="rounded rounded-sm w-full md:h-96 object-contain mx-auto"
                />
                <h2 className="text-2xl md:text-2xl font-serif mb-2 mt-4">Filippa</h2>
                <p className="leading-relaxed md:leading-normal max-w-prose">
                    Jag heter Filippa och har varit verksam frisör sedan 2019. Jag brinner för kvalitet & noggrannhet, form, helhetskänsla och att skapa personliga resultat anpassade efter varje kund.<br/>
                    <br/>
                    Jag lägger även starkt fokus på kundrelationer och personlig service, och för mig handlar hår inte bara om hantverk utan om att skapa ett lugnt, tryggt och personligt rum där du får känna dig sedd.
                    Efter en behandling hos mig är mitt mål att du ska lämna salongen med ett hår som känns som du, fast ännu lite bättre!</p>
            </div>
            </div>
        </section>
    )
}

export default OmOss;